/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Advantages_Sample_Ref_HeadingInputs */

const en_advantages_sample_ref_heading = /** @type {(inputs: Advantages_Sample_Ref_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`References`)
};

const es_advantages_sample_ref_heading = /** @type {(inputs: Advantages_Sample_Ref_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Referencias`)
};

/**
* | output |
* | --- |
* | "References" |
*
* @param {Advantages_Sample_Ref_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const advantages_sample_ref_heading = /** @type {((inputs?: Advantages_Sample_Ref_HeadingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Advantages_Sample_Ref_HeadingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_advantages_sample_ref_heading(inputs)
	return en_advantages_sample_ref_heading(inputs)
});